import { Component, computed, inject, input } from '@angular/core';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { DropDownFilterSettings, KENDO_DROPDOWNLIST, KENDO_DROPDOWNS, PopupSettings } from '@progress/kendo-angular-dropdowns';
import { KENDO_STACKLAYOUT } from '@progress/kendo-angular-layout';
import { KENDO_POPUP } from '@progress/kendo-angular-popup';
import { AgreementDetailedDto } from '@unity/clients';
import { DateTimezonePipe } from '@unity/pipes/date-timezone.pipe';
import { NavigationService } from '@unity/services/navigation.service';
import { ChipWorkflowStateSharedComponent } from '@unity/shared/presentation/chip-workflow-state-shared/chip-workflow-state-shared.component';

@Component({
  selector: 'unity-agreement-selector-shared',
  imports: [
    KENDO_DROPDOWNLIST,
    KENDO_BUTTON,
    KENDO_STACKLAYOUT,
    KENDO_DROPDOWNS,
    KENDO_POPUP,
    DateTimezonePipe,
    ChipWorkflowStateSharedComponent,
  ],
  templateUrl: './agreement-selector-shared.component.html',
  styleUrl: './agreement-selector-shared.component.scss',
})
export class AgreementSelectorSharedComponent {
  public readonly $data = input.required<AgreementDetailedDto[] | undefined>({ alias: 'data' });
  public readonly $isLoading = input.required<boolean>({ alias: 'isLoading' });
  public readonly $defaultItem = input.required<AgreementDetailedDto | undefined>({ alias: 'defaultItem' });

  private readonly navigationService = inject(NavigationService);

  protected readonly $all = computed(() => {
    return this.$data() ?? [];
  });

  protected filterSettings: DropDownFilterSettings = {
    operator: 'contains',
    caseSensitive: false,
  };

  protected popupSettings: PopupSettings = {
    width: 'auto',
    popupClass: 'agreement-selector-popup',
  };

  protected changeSelectedValue(value: AgreementDetailedDto) {
    this.navigationService.navigate(['/agreement', value.id, 'view']);
  }

  protected navitateToAgreementList() {
    this.navigationService.navigate(['/agreement']);
  }
}
